import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Är kunskapsprovet svårt?";
const SHORT_ANSWER = "Provet är hanterbart med fokuserad träning, men de flesta som chansar utan förberedelse blir underkända. Vanligaste fallet: att missa godkäntgränsen i ett enskilt område.";

export const Route = createFileRoute("/fraga/ar-provet-svart")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Är kunskapsprovet svårt" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Statistik från flera kommuner visar 30–50% underkända vid första försöket. Den som tränat på fokuserade övningsfrågor i 2–4 veckor klarar provet i hög grad."}
      source={{ label: "Folkhälsomyndigheten – Kunskapsprov", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/kunskapsprov/" }}
      extraSources={[]}
      deepGuide={{ to: "/kunskapsbank/hur-svart-ar-kunskapsprovet", label: "Hur svårt är kunskapsprovet" }}
      related={[{"to": "/fraga/hur-pluggar-jag-effektivt", "label": "Hur pluggar jag effektivt inför kunskapsprovet?"}, {"to": "/fraga/kan-jag-trana-gratis", "label": "Kan jag träna på kunskapsprovet gratis?"}, {"to": "/fraga/far-funktionshindrade-extra-tid", "label": "Får funktionshindrade extra tid på kunskapsprovet?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Är kunskapsprovet svårt?" },
      { name: "description", content: "Provet är hanterbart med fokuserad träning, men de flesta som chansar utan förberedelse blir underkända. Vanligaste fallet: att missa godkäntgränsen i ett en…" },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/ar-provet-svart" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/ar-provet-svart" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/ar-provet-svart",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Är kunskapsprovet svårt", url: "https://alkoholprovet.se/fraga/ar-provet-svart" },
      ]),
    ],
  }),
});
